import { createContext } from 'react';

const DropdownContext = createContext(null);

export default DropdownContext;
